/**
 * SEO slug helpers (Phase 3 — V5.0). Mirrors backend/utils/slug.py.
 */
export function slugify(text, maxLen = 70) {
  if (!text) return 'listing';
  let s = String(text).toLowerCase().trim();
  s = s.replace(/[^a-z0-9]+/g, '-').replace(/-{2,}/g, '-').replace(/^-+|-+$/g, '');
  if (s.length > maxLen) s = s.slice(0, maxLen).replace(/-+$/, '');
  return s || 'listing';
}

export function propertySlug(p = {}) {
  const parts = [
    p.bedrooms ? `${p.bedrooms}bhk` : null,
    p.sub_type,
    p.title,
    p.city,
  ].filter(Boolean);
  return slugify(parts.join(' '));
}

export function propertyPath(p = {}) {
  const id = p.property_id || p.id;
  return `/property/${propertySlug(p)}-${id}`;
}

export function rentalSlug(r = {}) {
  const parts = [
    r.bedrooms ? `${r.bedrooms}bhk` : null,
    r.property_type || r.sub_type,
    r.title || r.name,
    r.city || r.location,
  ].filter(Boolean);
  return slugify(parts.join(' '));
}

export function rentalPath(r = {}) {
  const id = r.rental_id || r.id;
  return `/rentals/${rentalSlug(r)}-${id}`;
}

/** Extract a real id (prop_xxx / rental_xxx) from a slugged URL segment. */
export function extractPropertyId(ref) {
  if (!ref) return ref;
  const m = String(ref).match(/(prop_[a-z0-9]+)/i);
  return m ? m[1] : ref;
}

export function extractRentalId(ref) {
  if (!ref) return ref;
  const m = String(ref).match(/(rental_[a-z0-9]+|rent_[a-z0-9]+)/i);
  return m ? m[1] : ref;
}

/** ── Partner profile slugs (Agent / Developer / Vendor) ── */
export function agentPath(a = {}) {
  const id = a.agent_id || a.id;
  const slug = slugify([a.name, a.company, a.city].filter(Boolean).join(' '));
  return `/agent/${slug}-${id}`;
}

export function developerPath(d = {}) {
  const id = d.developer_id || d.id;
  const slug = slugify([d.company || d.name, d.city].filter(Boolean).join(' '));
  return `/developer/${slug}-${id}`;
}

export function partnerPath(v = {}) {
  const id = v.partner_id || v.id;
  const slug = slugify([v.name, v.company_name, v.location?.city].filter(Boolean).join(' '));
  return `/vendor/${slug}-${id}`;
}

export function extractAgentId(ref) {
  if (!ref) return ref;
  const m = String(ref).match(/(agent_[a-z0-9]+)/i);
  return m ? m[1] : ref;
}

export function extractDeveloperId(ref) {
  if (!ref) return ref;
  const m = String(ref).match(/(dev_[a-z0-9]+)/i);
  return m ? m[1] : ref;
}

export function extractPartnerId(ref) {
  if (!ref) return ref;
  const m = String(ref).match(/(PTR_[a-z0-9]+)/i);
  return m ? m[1] : ref;
}

/** Public share URL (bot-aware backend endpoint) for rich link previews. */
export function propertyShareUrl(p = {}) {
  const id = p.property_id || p.id;
  return `${window.location.origin}/api/share/property/${propertySlug(p)}-${id}`;
}

export function rentalShareUrl(r = {}) {
  const id = r.rental_id || r.id;
  return `${window.location.origin}/api/share/rental/${rentalSlug(r)}-${id}`;
}
